import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
//slices
import { openModal } from '../../../../../../store/slices/searchSlice';
//assets
import DocsIcon from '../../../../icons/docsIcon';
import PlayIcon from '../../../../icons/playIcon';
import EyeIcon from '../../../../icons/eyeIcon';
import UploadIcon from '../../../../icons/uploadIcon';
import BuildingIcon from '../../../../icons/buildingIcon';
import MaterialSymbols from '../../../../icons/materialSymbols';
//components
import TableOptionsMenu from '../../../../TableWidget/components/TableOptionsMenu';
//constants
import { MODAL_TYPES } from '../../../../../../constants';
import ShareScan from '../../../../TableWidget/components/TableView/components/ShareScan';


const OptionsMenu = React.memo(({ pid, subject, tenancy_id, tenant_name, check_in, checkout, rent, deposit, email, mobile }) => {
    const dispatch = useDispatch();
    const menuItems = [
        {
            label: 'Edit Lease',
            icon: MaterialSymbols,
            onClick: () => dispatch(openModal({ modalName: MODAL_TYPES.UPDATE_TENANCY_MODAL, subject, pid, tenancy_id, tenant_name, check_in, checkout, rent, deposit, email, mobile })),
        },
        // {
        //     label: 'Remove Lease',
        //     icon: MaterialSymbols,
        //     onClick: () => dispatch(openModal({ modalName: MODAL_TYPES.DELETE_TENANCY_MODAL, tenancy_id, tenant_name, subject })),
        // },
    ];
    
    return (
        <TableOptionsMenu items={menuItems} />
    );
});

const ActionsPanelTenancies = ({ tenancy_id, tenant_name, pid, subject, check_in, checkout, rent, deposit, email, mobile, changeSetNotifState, }) => {
    const dispatch = useDispatch();

    return (
        <>
            <OptionsMenu
                pid={pid}
                subject={subject}
                tenancy_id={tenancy_id}
                tenant_name={tenant_name}
                check_in={check_in}
                checkout={checkout}
                rent={rent}
                deposit={deposit}
                email={email}
                mobile={mobile}
            />
        </>
    )
}

export default ActionsPanelTenancies;